import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from '@material-ui/core/Grid';
import bgBanner from '../Assets/bg_banner.jpg';
import mobileImage from '../Assets/mobile1.png';
import Container from "@material-ui/core/Container";
import {Hidden} from "@material-ui/core";
import Footer from 'Components/Footer';
import Header from 'Components/Header';

const useStyles = makeStyles( theme => ({
    backgroundBanner: {
        backgroundImage: `url(${bgBanner})`,
        backgroundPosition: 'bottom',
        width: '100%',
        height: 700
    },
    content: {
        paddingTop: 20,
        paddingBottom: 20,
        color: '#FFFFFF'
    },
    mobileImage: {
        marginTop: 70,
        height: 500
    },
    textContent: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        height: 500,
        width: '100%'
    }
}));

const ConnectionAdded = ({added}) => {
    const classes = useStyles();

    return (
        <>
        <Header />
        <div className={classes.backgroundBanner}>
            <Container className={classes.content}>
                <Grid container>
                    <Grid xs={12} md={6} className={classes.textContent} style={{ display: 'flex', alignContent: 'center', justifyContent: 'center'}}>
                        {added && <h1>Connection Added!</h1>}
                        {!added && <h1>Connection Not Added!</h1>}
                    </Grid>
                    <Hidden smDown>
                        <Grid md={6} style={{ display: 'flex', alignContent: 'center', justifyContent: 'center'}} >
                            <img className={classes.mobileImage} src={mobileImage}/>
                        </Grid>
                    </Hidden>
                </Grid>
            </Container>
        </div>
        <Footer />
        </>
    );
};

export default ConnectionAdded;
